import apiClient from './apiClient'

export { getClassicalDetail, getPromotionList }

async function getClassicalDetail({ classicalProjectId }) {
  const res = await apiClient.get('getClassicalDetail.do', {
    params: {
      classicalProjectId
    }
  })

  return res.data
}

async function getPromotionList(params) {
  const res = await apiClient.get('getClassicalProject.do', {
    params: {
      caseType: 3,
      ...params
    }
  })
  return res.data.projectList
}
